<template>
    <div class="master-section double-column-cta-layout">
        <div :class="['row justify-content-center px-0 px-md-1 mb-40px mb-md-60px mx-0 mx-md-1' , data_col_cta.column_position ]">
            <div class="cta-column col-12 col-md-6 ">
                <div class="cta-column__container">
                    <div class="cta-column__4-images" v-if="data_col_cta.content_type == 'image'">
                        <img :src="data_col_cta.image_1_full" :alt="data_col_cta.image_1_alt ?? ''" class="img-fluid image-1">
                        <img :src="data_col_cta.image_2_full" :alt="data_col_cta.image_2_alt ?? ''" class="img-fluid image-2">
                        <img :src="data_col_cta.image_3_full" :alt="data_col_cta.image_3_alt ?? ''" class="img-fluid image-3">
                        <img :src="data_col_cta.image_4_full" :alt="data_col_cta.image_4_alt ?? ''" class="img-fluid image-4">
                    </div>
                    <div class="cta-column__4-products" v-if="data_col_cta.content_type == 'product'">
                        <div v-for="(item, index) in data_product">
                            <ListingItem
                                :item=item
                                :min_max="true"
                            />
                        </div>
                    </div>
                    <div v-if="data_col_cta.button.url !== '' && data_col_cta.button.title" class="cta-column__cta-button">
                        <a class="cta-column__link" :href="data_col_cta.button.url" :target="data_col_cta.button.target || '_self'">
                            <span>{{ data_col_cta.button.title }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="lifestyle col-12 col-md-6 pl-md-0 pr-md-0">
                <div class="lifestyle__container">
                    <a :href="data_col_cta.lifestyle_link.url" :target="data_col_cta.lifestyle_link.target || '_self'" class="lifestyle__link">
                        <img :src="data_col_cta.lifestyle_image_full" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import ListingItem from "~/components/Product/ProductItem.vue";
    const key_product = ref('');
    const data_product = ref();
    const props = defineProps(["data", "data_item"]);

    const data_col_cta = computed(() => props.data);
    const data_product_item = computed(() => props.data_item);

    watch(
        () => [data_col_cta.value, data_product_item.value], 
        ([newDataColCta, newDataProductItem]) => {
            if (newDataColCta?.product_section_id && newDataProductItem) {
            key_product.value = newDataColCta.product_section_id;

            const filteredProducts = newDataProductItem[key_product.value]?.filter(
                (product) => product.status !== "outofstock"
            );

            data_product.value = filteredProducts || [];
                // console.log('Updated data_product:', data_product.value);
            } else {
                data_product.value = []; 
            }
        },
        { immediate: true } 
    );
    // console.log('123123', data_product.value);


  
</script>
<style scoped lang="scss">
@import "@/assets/scss/components/listing/listingItem.scss";
</style>